import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_details",
  "use": "icon-project_details-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-project_details\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M8.39,14.1h4.33v1.4H8.39Zm0-2.8h4.33v1.4H8.39ZM9.83,7.8h5.78v7h1.45V6.4H9.83ZM7,9.2v8.4h7.23V9.2ZM8.39,7.8V5.7A.71.71,0,0,1,9.11,5h8.67a.71.71,0,0,1,.72.7v9.8a.71.71,0,0,1-.72.7H15.61v2.1a.71.71,0,0,1-.73.7H6.23a.75.75,0,0,1-.52-.2.71.71,0,0,1-.21-.5V8.5a.72.72,0,0,1,.73-.7Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol